<ngx-heka-table-layout>
  <ng-container input-fields>
    <ngx-heka-search-input (searchEvent)="searchTextChanged($event)" [searchText]="searchText()"
      [readonly]="(loadingService.getLoading().asObservable()|async)||false"
      searchPlaceholderText="{{'MULTI_DOMAIN.TABLE.SEARCH'|translate}}">

    </ngx-heka-search-input>
  </ng-container>
  <ng-container actions>
    <button mat-flat-button color="primary" (click)="onCreateDomain.emit()"
      [disabled]="hasSanctionedDomain()">
      <mat-icon>add</mat-icon>
      {{ 'MULTI_DOMAIN.TABLE.CREATE'|translate }}
    </button>
  </ng-container>
  <ng-container container>
    <div class="heka-m3-table">
      <table mat-table [dataSource]="filteredDomains()">
        <ng-container matColumnDef="companyName">
          <th mat-header-cell *matHeaderCellDef>{{ 'MULTI_DOMAIN.TABLE.NAME'|translate }}</th>
          <td mat-cell *matCellDef="let row">
            <span>{{ row?.companyName }}</span>
            <br>
              @if (row?.administrativeAccess) {
                <span class="sub-line">{{ 'MULTI_DOMAIN.TABLE.ADMIN' | translate }}</span>
              } @else {
                <span class="sub-line">{{ 'MULTI_DOMAIN.TABLE.STANDARD' | translate }}</span>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="domainState">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row" class="text-end">
              @if (row?.domainType == domainTypes.BLACKLISTED) {
                <div class="heka-m3-state-tag-info">
                  {{ 'MULTI_DOMAIN.TABLE.BLACKLISTED' |translate }}
                </div>
              } @else if (row?.active) {
                <div class="heka-m3-state-tag-success">
                  {{ 'MULTI_DOMAIN.TABLE.ACTIVE' |translate }}
                </div>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>
            </th>
            <td mat-cell *matCellDef="let row">
              <div class="ngx-heka-table-actions">
                <button mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="onLeaveDomain(row)">
                    <mat-icon>exit_to_app</mat-icon>
                    <span>{{ 'MULTI_DOMAIN.TABLE.ACTIONS.LEAVE'|translate }}</span>
                  </button>
                  @if (row?.administrativeAccess) {
                    <button mat-menu-item (click)="onEditDomain(row)">
                      <mat-icon class="material-icons-outlined">edit</mat-icon>
                      <span>{{ 'MULTI_DOMAIN.TABLE.ACTIONS.EDIT'|translate }}</span>
                    </button>
                    <button mat-menu-item (click)="onDeleteDomain(row)">
                      <mat-icon class="material-icons-outlined">delete</mat-icon>
                      <span>{{ 'MULTI_DOMAIN.TABLE.ACTIONS.DELETE'|translate }}</span>
                    </button>
                  }
                </mat-menu>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns(); sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns();"
            [class.disabled-row]="row?.domainType == domainTypes.BLACKLISTED">
          </tr>
        </table>
        @if ((filteredDomains()?.length??0)<1) {
          <div class="heka-m3-empty-table-row">
            {{ 'MULTI_DOMAIN.TABLE.SHOW_NO_DOMAINS' |translate }}
          </div>
        }
      </div>
      <div class="button-box">
        <button mat-button color="primary" (click)="onCreateDomain.emit()"
          [disabled]="hasSanctionedDomain()">
          <mat-icon>add</mat-icon>
          {{ 'MULTI_DOMAIN.TABLE.CREATE'|translate }}
        </button>
      </div>
      <ngx-heka-paginator [totalCount]="filteredDomains().length||0"
        entryTextSingular="{{'GENERAL.PAGER.ENTRY'|translate}}"
        entryTextPlural="{{'GENERAL.PAGER.ENTRIES'|translate}}"
        [countOnly]="true">
      </ngx-heka-paginator>
    </ng-container>
  </ngx-heka-table-layout>